export function primeAmount(value) {
  if (value == null || String(value).trim() === '') return null;
  const number = Number(String(value).replace(',', '.'));
  return Number.isFinite(number) ? number : null;
}

export function primeSummary(row) {
  const quantity = primeAmount(row.quantite);
  const amount = primeAmount(row.montant);
  if (amount === null) return `Quantité : ${quantity ?? '—'} · Montant non renseigné`;
  const euro = value => value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `(${quantity ?? '—'} × ${euro(amount)} €${quantity === null ? '' : ` = ${euro(quantity * amount)} €`})`;
}
